import React from 'react';
import { Sparkles, Scissors, Lightbulb, User, Key } from 'lucide-react';
import { stylePoints } from '../../mock';
import LadiesImage from "../../assets/style.jpg";

const iconMap = { Sparkles, Scissors, Lightbulb, User, Key };

export default function StyleYourWay() {
  return (
    <section className="py-16 md:py-20 bg-gradient-to-br from-pink-50/50 via-white to-pink-50/50">
      <div className="max-w-6xl mx-auto px-5 md:px-8 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left image */}
        <div className="relative">
          <div className="rounded-[32px] overflow-hidden shadow-xl shadow-pink-200/40 border-8 border-white">
            <img
              src={LadiesImage}
              alt="Style your way"
              className="w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-6 rounded-2xl bg-white p-4 shadow-xl border border-pink-100 animate-floaty">
            <div className="text-xs text-slate-500">Personalised for you</div>
            <div className="mt-1 text-lg font-bold text-[#E91E80]">100+ Designs</div>
          </div>
        </div>

        {/* Right text */}
        <div>
          <h2 className="zp-section-title">
            Style your way, <span className="zp-gradient-text">only a click away</span>
          </h2>
          <p className="mt-4 text-slate-600 leading-relaxed max-w-lg">
            Trendy twists, bespoke fixes, innovative, personalised, and unique solutions — all in one place.
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {stylePoints.map(p => {
              const Icon = iconMap[p.icon] || Sparkles;
              return (
                <div key={p.label} className="flex items-center gap-3 rounded-2xl bg-white border border-pink-100 px-4 py-3 hover:border-[#E91E80] hover:bg-pink-50/60 transition-colors">
                  <span className="h-10 w-10 grid place-items-center rounded-xl bg-pink-100 text-[#E91E80] flex-shrink-0">
                    <Icon size={20} />
                  </span>
                  <span className="font-medium text-slate-800">{p.label}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
